import { createStore } from '@atlas-frontend/sdk';
import { FC, PropsWithChildren } from 'react';

export interface InputDataContextValue {
  loadingError?: string;
}

export const InputDataStore = createStore<InputDataContextValue>();
export const useInputDataStore = InputDataStore.useValue;

export const InputDataContextProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <InputDataStore.Provider initialData={{}}>
      {children}
    </InputDataStore.Provider>
  );
};
